export function toTradingViewSymbol(symbol) {
  return `BINANCE:${symbol}`;
}

export function toTradingViewTechnicalsUrl(symbol) {
  return `https://www.tradingview.com/symbols/BINANCE-${symbol}/technicals/`;
}